import React from 'react';
import { format } from 'date-fns';
import * as PropTypes from 'prop-types';

import { SvgIcon } from '../../svg-icon';
import { getCurrentUserId } from '../../../utils';
import { ReactQuillWrapped } from '../../react-quill';
import { Popconfirm } from '../../popovers/popconfirm';
import {
  Date,
  Creator,
  CreatorName,
  CreatorData,
  CommentWrap,
  ControlsWrap,
  CreatorAvatar,
  CreatorDataWrap,
} from './styles';


const DATE_FORMAT = 'HH:mm d MMM yyyy';

const CommentControl = ({
  _id, handleCommentDelete, openCommentModal,
}) => (
  <ControlsWrap>
    <SvgIcon
      type="pencil"
      onClick={() => openCommentModal(_id)}
    />
    <Popconfirm
      title="Are you sure to delete this comment?"
      onConfirm={() => handleCommentDelete(_id)}
    >
      <SvgIcon
        type="trash"
        fillOpacity={0.5}
        style={{ margin: '-1px 0 0 10px' }}
        data-popconfirm-stay-open
      />
    </Popconfirm>
  </ControlsWrap>
);

CommentControl.propTypes = {
  _id: PropTypes.string.isRequired,
  openCommentModal: PropTypes.func.isRequired,
  handleCommentDelete: PropTypes.func.isRequired,
};

const Comment = ({
  createdBy, text, createdAt, ...rest
}) => (
  <CommentWrap>
    <CreatorDataWrap>
      <Creator>
        <CreatorAvatar src={createdBy.profileImage} />
        <CreatorData>
          <CreatorName>{createdBy.fullName}</CreatorName>
          <Date>{format(createdAt, DATE_FORMAT)}</Date>
        </CreatorData>
      </Creator>
      {
        getCurrentUserId() === createdBy._id &&
        <CommentControl {...rest} />
      }
    </CreatorDataWrap>
    <ReactQuillWrapped theme={null} value={text} readOnly />
  </CommentWrap>
);

Comment.propTypes = {
  text: PropTypes.string.isRequired,
  createdAt: PropTypes.string.isRequired,
  createdBy: PropTypes.object.isRequired,
};

export default Comment;



// WEBPACK FOOTER //
// ./src/components/comments-list/comment/index.js